




























































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import * as prestazioneApi from '../services/prestazione-api';
import {
    PrestazioneDetailViewModel,
    StatoPrestazioneEnum,
    EditCommand,
    ExpansionPanel
} from '../types';
import validationRulesMixin from '../components/mixin/validation-rules-mixin';
import avvocatoSelector from '@/components/selectors/AvvocatoSelector.vue';
import enteSanitarioSelector from '@/components/selectors/EnteSanitarioSelector.vue';
import compagniaAssicurativaSelector from '@/components/selectors/CompagniaAssicurativaSelector.vue';
import operatoreSanitarioSelector from '@/components/selectors/OperatoreSanitarioSelector.vue';
import attributoSelector from '@/components/selectors/AttributoSelector.vue';
import richiedenteSelector from '@/components/selectors/RichiedenteSelector.vue';
import pazienteSelector from '@/components/selectors/PazienteSelector.vue';
import relazioneMedicaEdit from '@/components/commands/RelazioneMedicaEdit.vue';
import prestazioneLogStato from '@/components/commands/PrestazioneLogStato.vue';
import prestazionePrint from '@/components/print/PrestazionePrint.vue';

export default Vue.extend({
    mixins: [validationRulesMixin],

    components: {
        avvocatoSelector,
        enteSanitarioSelector,
        compagniaAssicurativaSelector,
        operatoreSanitarioSelector,
        attributoSelector,
        richiedenteSelector,
        pazienteSelector,
        relazioneMedicaEdit,
        prestazioneLogStato,
        prestazionePrint
    },
    data(): PrestazioneDetailViewModel {
        return {
            item: null,
            isValid: false,
            hasRelazioneMedica: false,
            panels: [0],
            isRelazioneValid: true,
            statoLogDialog: false,
            showPrestazionePrint: false,
            selectedTab: null,
            prossimoStatoId: 1
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
        isAllValid(): boolean {
            return this.isValid && this.isRelazioneValid;
        },
        canSetNextStatus(): boolean {
            return (
                !this.isNew &&
                this.item?.ultimoStatoId !== StatoPrestazioneEnum.TerminataId &&
                this.item?.ultimoStatoId !==
                    StatoPrestazioneEnum.PassataAlMedicoId
            );
        },
        canSetTerminata(): boolean {
            return (
                !this.isNew &&
                this.item?.ultimoStatoId !== StatoPrestazioneEnum.TerminataId
            );
        },
        canReopen(): boolean {
            return (
                !this.isNew &&
                this.item?.ultimoStatoId === StatoPrestazioneEnum.TerminataId
            );
        },
        statoCorrenteId(): number {
            return this.item ? this.item.ultimoStatoId : 0;
        },

        canViewRelazioneMedica(): boolean {
            return (
                !this.isNew &&
                this.item?.ultimoStatoId !== StatoPrestazioneEnum.InseritaId &&
                this.item?.ultimoStatoId !==
                    StatoPrestazioneEnum.PresaInCaricoId
            );
        },
        canSave(): boolean {
            return (
                this.item?.ultimoStatoId !== StatoPrestazioneEnum.TerminataId
            );
        }
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await prestazioneApi.getByKey(id);
                this.hasRelazioneMedica = this.item.hasRelazioneMedica ?? false;
            } else {
                this.item = {
                    id: 0,
                    version: 0,
                    avvocatoId: 0,
                    utenteId: 0,
                    ultimoStatoId: 0,
                    pazienteId: 0,
                    dataEvento: new Date(),
                    consulenteTecnicoParte: '',
                    enteSanitarioUnitaOperativa: '',
                    dannoLamentato: '',
                    procedimentoPenale: false,
                    procedimentoCivile: false,
                    procedimentoPenaleNotePreBozza: '',
                    procedimentoCivileNotePreBozza: '',
                    conciliazione: '',
                    notePrestazione: '',
                    periziando: false,
                    ctuPresenti: '',
                    ctpAttorei: '',
                    ctpAltriConvenuti: '',
                    notePromemoria: '',
                    displayName: this.$i18n.t('labels.nuovo').toString()
                };
            }
        },
        close() {
            this.statoCorrenteId === 0
                ? this.$router.push({
                      name: 'Prestazioni'
                  })
                : this.$router.push({
                      name: 'PrestazioniStato',
                      params: { statusId: this.statoCorrenteId.toString() }
                  });
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await prestazioneApi.create(this.item);
            } else {
                response = await prestazioneApi.update(this.item);
                if (this.canViewRelazioneMedica) {
                    (this.$refs.relazioneEdit as EditCommand).save();
                }
            }
            this.loadData(response.id);
        },
        expandAll() {
            this.panels = [];
            const length = (this.$refs.expansionPanels as ExpansionPanel).items
                .length;
            for (let i = 0; i < length; i++) {
                this.panels.push(i);
            }
            (this.$refs.relazioneEdit as EditCommand).expandAll();
        },
        collapseAll() {
            this.panels = [];
            (this.$refs.relazioneEdit as EditCommand).collapseAll();
        },
        print() {
            if (this.selectedTab !== 1) {
                this.showPrestazionePrint = true;
            } else {
                (this.$refs.relazioneEdit as EditCommand).print();
            }
        },
        async onStatusSave() {
            if (!this.item) {
                return;
            }
            await this.loadData(this.item.id);
            this.statoLogDialog = false;
        },
        changeStatus(statusId: number) {
            this.prossimoStatoId = statusId;
            this.statoLogDialog = true;
        }
    },
    async mounted() {
        await this.loadData(parseInt(this.$route.params.id));
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    }
});
